<template>
  <div class="md:grid md:grid-cols-4 md:gap-16">
    <RevCard class="rounded-sm col-span-3 p-24">
      <h2 class="heading-1 mb-16">
        {{ i18n(translations.pageTitle) }}
      </h2>
      <div class="md:grid md:grid-cols-3 md:gap-16">
        <LiveWallet :info="liveWallet" />
        <UpcomingPayouts
          class="mt-4 md:col-span-2 md:mt-0"
          :info="upcomingPayouts"
        />
      </div>
    </RevCard>
    <DeferredPayout class="mt-4 md:mt-0" :info="deferredPayout" />
  </div>
</template>

<script setup lang="ts">
import { type Error, getApiErrorMessage } from '#imports'
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'
import { RevCard } from '@ds/components/Card'

import translations from './Wallet.translations'
import DeferredPayout from './components/DeferredPayout/DeferredPayout.vue'
import LiveWallet from './components/LiveWallet/LiveWallet.vue'
import UpcomingPayouts from './components/UpcomingPayouts/UpcomingPayouts.vue'

const i18n = useI18n()
const { openErrorToast } = useTheToast()

const { data, error } = await useHttpFetch(merchantsAPI.getSellerWallet)

if (error.value) {
  openErrorToast({
    content: getApiErrorMessage(error.value as unknown as Error),
  })
}

const liveWallet = computed(() => data.value?.live_wallet || {})
const upcomingPayouts = computed(() => data.value?.planned_payouts || [])
const deferredPayout = computed(() => data.value?.deferred_payout || {})
</script>
